typeof(gsap) !== "undefined" && gsap.registerPlugin(ScrollTrigger);

(function ($) {
  /**
   * Check element is in viewport or not
   * @returns 
   */
  // function isInViewport() {
  //   var elementTop = $(this).offset().top;
  //   var elementBottom = elementTop + $(this).outerHeight();

  //   var viewportTop = $(window).scrollTop();
  //   var viewportBottom = viewportTop + $(window).height();

  //   return elementBottom > viewportTop && elementTop < viewportBottom;
  // }

  // function bindEvents() {
  //   $(".c-hamburger").on("click", () => {
  //     const $header = $(".header");

  //     if ($header.hasClass("is-opened")) {
  //       $header.removeClass("is-opened");
  //       // enableScrolling();
  //     } else {
  //       $header.addClass("is-opened");
  //       // disableScrolling();
  //     }
  //   });
  // }

  /**
     * Init slick slider only on mobile device
     *
     * @param {DOM} $slider
     * @param {array} option - slick slider option
     */
  function mobileSlider($slider, option) {
    if (window.matchMedia('(max-width: 768px)').matches) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick(option);
      }
    } else if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  /**
   * Init Tabs
   */
  function initTab() {
    // Toggle tab on click tab link
    // $(".c-tab__link").on("click", function () {
    //   if ($(this).hasClass("is-active")) return;
    //   let id = $(this).attr("href");
    //   $(".c-tab__link.is-active").removeClass("is-active");
    //   $(".c-tab__content.is-active").removeClass("is-active");
    //   $(this).addClass("is-active");
    //   $(id).addClass("is-active");
    //   return false;
    // });
  }

  /**
   * Init Video Tab
   */
  function initVideoTab() {
    // play current active video when visible on section
    // $(".c-tab__content.is-active video").viewportChecker({
    //   offset: 50,
    //   callbackFunction: function (element) {
    //     element.get(0).play();
    //   }
    // });
    // // play video on click tab links
    // $(".c-tab__link").on("click", function () {
    //   let id = $(this).attr("href"),
    //     $content = $(id);
    //   $("html, body").animate({
    //     scrollTop: $content.offset().top + 10
    //   }, 700);
    //   return false;
    // });
    // // make all videos autoplay on mobile, disable if desktop view
    // updateVideoTabVideos();
    // function updateVideoTabVideos() {
    //   if (window.matchMedia("(min-width: 769px)").matches) {
    //     $(".c-video-tab__video").each(function () {
    //       this.pause();
    //     });
    //   } else {
    //     $(".c-video-tab__video").each(function () {
    //       this.play();
    //     });
    //   }
    // }
    // windowResize(updateVideoTabVideos);
    // gsap.to(".c-tab__links", {
    //   scrollTrigger: {
    //     trigger: ".c-tab__contents",
    //     start: "top top",
    //     end: "bottom center",
    //     scrub: true,
    //     onEnter() {
    //       $(".c-tab__links").addClass("sticky");
    //     },
    //     onLeave() {
    //       $(".c-tab__links").removeClass("sticky");
    //     },
    //     onEnterBack() {
    //       $(".c-tab__links").addClass("sticky");
    //     },
    //     onLeaveBack() {
    //       $(".c-tab__links").removeClass("sticky");
    //     }
    //   }
    // })
  //   gsap.utils.toArray(".c-sticky-section__right-container").forEach((tab) => {
  //     const id = tab.getAttribute("id");
  //     let video = tab.querySelector(".c-video-tab__video");
  //     ScrollTrigger.matchMedia({
  //       "(max-width: 768px)": function () {
  //         ScrollTrigger.create({
  //           trigger: tab,
  //           ease: "none",
  //           start: "top center",
  //           end: "bottom top",
  //           toggleClass: "is-active",
  //           onEnter() {
  //             if ( video ) {
  //               video.play();
  //               $(tab).css('opacity', 1);
  //             }
  //           },
  //           onLeave() {
  //             if ( video ) {
  //               video.pause();
  //               $(tab).css('opacity', 0.2);
  //             }
  //           },
  //           onEnterBack() {
  //             if ( video ) {
  //               video.play();
  //               $(tab).css('opacity', 1);
  //             }
  //           },
  //           onLeaveBack() {
  //             if ( video ) {
  //               video.pause();
  //               $(tab).css('opacity', 0.2);
  //             }
  //           },
  //         });
  //       },
  //       "(min-width: 769px)": function() {
  //         ScrollTrigger.create({
  //           trigger: tab,
  //           ease: "none",
  //           start: "center center",
  //           end: "bottom center",
  //           toggleClass: "is-active",
  //           onUpdate() {
  //             let id = $(tab).attr('id'),
  //                 $video = $(`#${id}-video`),
  //                 $link = $(`.c-tab__link[href=#${id}]`);
  //             if ( ! $video.hasClass("is-active") && $video.length ) {
  //               $(".c-video-tab__video.is-active").removeClass("is-active");
  //               $video.addClass("is-active");
  //               $video.get(0).play();
  //             }
  //             if ( ! $link.hasClass("is-active") && $link.length ) {
  //               $(".c-tab__link.is-active").removeClass("is-active");
  //               $link.addClass("is-active");
  //             }
  //           }
  //         })
  //       }
  //     })
  //   });
  //   ScrollTrigger.matchMedia({
  //     "(min-width: 769px)": function() {
  //       ScrollTrigger.create({
  //         trigger: $(".c-video-tab__static"),
  //         start: "top top",
  //         endTrigger: $(".c-tab__contents"),
  //         end: "bottom bottom",
  //         pin: $(".c-video-tab__static"),
  //         pinSpacing: false,
  //         scrub: true,
  //       });
  //     }
  //   })
  }

  /**
   * Init home scroll section
   */
  function initHomeScroll() {
    // Play video when visible on section
    // $(".c-home-scroll__video").viewportChecker({
    //   offset: 50,
    //   callbackFunction: function (element) {
    //     element.get(0).play();
    //   }
    // });

    // Parallax effect
    if (typeof(gsap) !== "undefined") {
        gsap.to(".c-home-scroll__video", {
        yPercent: 50,
        scrollTrigger: {
          trigger: ".c-home-scroll__s2__content",
          scrub: true,
          start: "top bottom",
          end: "bottom top"
        }
      });
    }
  }

  /**
   * Init full page
   */
  // function initFullPage() {
  //   let options =  {
  //     licenseKey: 'E0K28-TTO6I-LKW77-QJKLI-MABXL',
  //     navigation: false,
  //     scrollBar: true,
  //     scrollingSpeed: 1000,
  //     scrollOverflow: false,
  //     sectionSelector: 'section',
  //     credits: false,
  //     responsiveWidth: 800
  //   }
  //   if( $(".o-scrollable-content").length ) {
  //     options['normalScrollElements'] = '.o-scrollable-content'
  //   }
  //   new fullpage("#fullpage", options);
  // }

  /**
   * Init count up
   */
  // function initCountUp() {
  //   ScrollTrigger.create({
  //     trigger: ".c-home-scroll__s1",
  //     start: "top center",
  //     end: "bottom top",
  //     onEnter() {
  //       const items = document.querySelectorAll(".c-count-up span");

  //       gsap.from(items, {
  //         textContent: 0,
  //         duration: 1,
  //         ease: Power1.easeIn,
  //         snap: { textContent: 1 },
  //         stagger: 1,
  //         // onUpdate: textContent.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
  //       });
  //     },
  //   })
  // }
  
  /**
   * Consumer Banner
   */
  function initConsumerBanner() {
    $(".c-consumer-banner .c-banner__form__input").focus(function() {
      $(this).attr('placeholder', 'eg.QTU54F49');
    }).blur(function() {
      $(this).attr('placeholder', 'I have a tracking number');
    })
  }

  /**
   * Init three columns banner
   */
  function initThreeColumnsBanner() {
    let $slider = $(".c-three-columns-banner__row"),
      option = {
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        variableWidth: true,
      };
    mobileSlider($slider, option);
    windowResize(initThreeColumnsBanner);
  }
  /**
   * Init vertical text slider
   */
  function initVerticalTextSlider() {
    let height = $(".c-text-vertical-slider h4").outerHeight() + 'px';
    $(".c-text-vertical-slider").slick({
      arrows: false,
      dots: false,
      vertical: true,
      autoplay: true,
      autoplaySpeed: 1000,
      centerMode: true,
      centerPadding: height
    });
  }

  function initImageTabs() {
    setInterval(() => {
      let $currentImage = $(".c-image-tabs__image.is-active"),
        currentId = $currentImage.attr('href');
        $next = $currentImage.next();
      $(currentId).removeClass("is-active");
      $currentImage.removeClass("is-active");
      if ( $next.length ) {
        let nextId = $next.attr('href');
        $next.addClass("is-active");
        $(nextId).addClass("is-active");
      } else {
        $(".c-image-tabs__image:first-child").addClass("is-active");
        let nextId = $(".c-image-tabs__image:first-child").attr('href');
        $(nextId).addClass("is-active");
      }
    }, 3000);
  }

  function initSlider() {
    $(".c-slider__carousel").slick({
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1000,
      variableWidth: true
    });
  }

  function initProductSlider() {
    const swiper = new Swiper(".c-product-slider .swiper", {
      // loop: true,
      autoplay: true,
      speed: 1000,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      }
    })
  }

  /**
   * Dot Animation
   */
    function initDotAnimation() {
      let dot,
          dotSection,
          shrunk = false;

      window.addEventListener("DOMContentLoaded", () => {
        dot = document.querySelector(".c-dot");
        dotSection = document.querySelector(".c-banner-dot");

        if ( dotSection.getBoundingClientRect().top <= (window.innerHeight/3)*2 && !shrunk ) {
          dot.classList.add("shrunk");
          shrunk = true;
        }
        
        window.addEventListener("scroll", () => {
          if ( dotSection.getBoundingClientRect().top <= (window.innerHeight/3)*2 && !shrunk ) {
            dot.classList.add("shrunk");
            shrunk = true;
          }
        });
      });
    }

  /* FUNCTION CALLS */
  /* ============= */

  // bindEvents();

  // viewportCheckerAnimate function
  viewportCheckerAnimate(".a-bg-up", "_animate");
  viewportCheckerAnimate(".a-bg-down", "_animate");
  viewportCheckerAnimate(".a-up", "fadeInUp", true);
  viewportCheckerAnimate(".a-up-toggle", "fadeInUp", true, 500);
  viewportCheckerAnimate(".a-down", "fadeInDown");
  viewportCheckerAnimate(".a-left", "fadeInLeft");
  viewportCheckerAnimate(".a-right", "fadeInRight");
  viewportCheckerAnimate(".a-op", "fade");

  // isElementExist("#fullpage", initFullPage);
  // isElementExist("#header-refresh", initHeader);
  isElementExist(".c-tab", initTab);
  // isElementExist(".c-video-tab", initVideoTab);
  isElementExist(".c-home-scroll", initHomeScroll);
  // isElementExist(".c-count-up", initCountUp);
  // isElementExist(".c-banner", initBannerAnimation);
  isElementExist(".c-consumer-banner", initConsumerBanner);
  isElementExist(".c-three-columns-banner", initThreeColumnsBanner);
  isElementExist(".c-text-vertical-slider", initVerticalTextSlider);
  isElementExist(".c-image-tabs", initImageTabs);
  isElementExist(".c-slider", initSlider);
  isElementExist(".c-product-slider", initProductSlider);
  isElementExist(".c-dot", initDotAnimation);

  // $(window).on("scroll", () => {
  //   if ($(window).scrollTop() > 50) $(".header").addClass("sticky");
  //   else $(".header").removeClass("sticky");
  // });

  // $(window).on("load", () => { });

  /***
   * Custom Helpers
   */

  // custom helper function for debounce - how to work see https://codepen.io/Hyubert/pen/abZmXjm
  /*
   * Debounce
   * need for once call function
   *
   * @param { function } - callback function
   * @param { number } - timeout time (ms)
   * @return { function }
   */
  function debounce(func, timeout) {
    var timeoutID,
      timeout = timeout || 200;
    return function () {
      var scope = this,
        args = arguments;
      clearTimeout(timeoutID);
      timeoutID = setTimeout(function () {
        func.apply(scope, Array.prototype.slice.call(args));
      }, timeout);
    };
  }

  // helper windowResize
  function windowResize(functName) {
    $(window).on("resize orientationchange", debounce(functName, 200));
  }

  // Helper if element exist then call function
  function isElementExist(_el, _cb, _argCb) {
    var elem = document.querySelector(_el);
    if (elem) {
      try {
        if (arguments.length <= 2) {
          _cb();
        } else {
          _cb(..._argCb);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  // viewportCheckerAnimate function
  function viewportCheckerAnimate(
    whatElement,
    whatClassAdded,
    classAfterAnimate,
    offsetTrigger = 10
  ) {
    jQuery(whatElement)
      .addClass("a-hidden")
      .viewportChecker({
        classToRemove: "a-hidden",
        classToAdd: "animated " + whatClassAdded,
        offset: offsetTrigger,
        callbackFunction: function (elem) {
          if (classAfterAnimate) {
            elem.on("animationend", function () {
              elem.addClass("animation-end");
            });
          }
        },
      });
  }
})(jQuery)